import { LOAD_WISHLIST, ADD_TO_WISHLIST, REMOVE_FROM_WISHLIST } from "./types";

const initialState = {
  items: {},
  loading: true,
};

export default function wishlistReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_WISHLIST:
      return { items: action.payload, loading: false };
    case ADD_TO_WISHLIST:
      return {
        ...state,
        items: { ...state.items, [action.payload.imdbID]: action.payload },
      };
    case REMOVE_FROM_WISHLIST: {
      const newItems = { ...state.items };
      delete newItems[action.payload];
      return { ...state, items: newItems };
    }
    default:
      return state;
  }
}
